import angular from 'angular';
import { ForwardMailMilitaryComponent } from './military.component';
import { ForwardMailMilitaryConfig } from './military.config';
import { CardModule } from '../../../../core';
import {
  RelevantContentComponent,
  StepPageModule,
} from '../../../../common/directives';

export const ForwardMailMilitaryModule = angular
  .module('app.steps.forward-mail.military', [
    RelevantContentComponent.name,
    StepPageModule.name,
    CardModule.name,
  ])
  .config(ForwardMailMilitaryConfig)
  .component('updForwardMailMilitary', ForwardMailMilitaryComponent);
